import React, { useState, useEffect, useRef } from "react";
import "./TaskPrioritySelector.css";

function TaskPrioritySelector({ currentPriority, onPriorityChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const priorities = [1, 2, 3, 4, 5];

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleSelectPriority = (priority, e) => {
    e.stopPropagation();
    onPriorityChange(priority);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const displayPriority =
    currentPriority === null || currentPriority === undefined
      ? "-"
      : String(currentPriority);

  const getPriorityClass = (priorityValue) => {
    if (
      priorityValue === null ||
      priorityValue === undefined ||
      priorityValue === "-"
    ) {
      return "priority-none";
    }
    return `priority-${priorityValue}`;
  };

  return (
    <div className="task-priority-selector-container" ref={dropdownRef}>
      <span
        className={`task-priority-display-value ${getPriorityClass(
          currentPriority
        )}`}
        onClick={toggleDropdown}
        title={`Priority: ${
          displayPriority === "-" ? "Not set" : displayPriority
        }`}
      >
        {displayPriority}
      </span>
      {isOpen && (
        <div className="priority-dropdown-menu">
          <div
            className={`priority-option-item ${getPriorityClass(null)} ${
              currentPriority === null || currentPriority === undefined
                ? "selected"
                : ""
            }`}
            onClick={(e) => handleSelectPriority(null, e)}
          >
            - (No Priority)
          </div>
          {priorities.map((p) => (
            <div
              key={p}
              className={`priority-option-item ${getPriorityClass(p)} ${
                currentPriority === p ? "selected" : ""
              }`}
              onClick={(e) => handleSelectPriority(p, e)}
            >
              {p}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TaskPrioritySelector;
